import { defineComponent, Teleport } from 'vue'

export default defineComponent({
  name: 'BodyPortal',
  props: {
    active: {
      type: Boolean,
      default: false,
    }
  },
  setup(props, { slots }) {
    return () => {
      if (!props.active) {
        return slots.default?.()
      }
      return (
        <Teleport to="body">
          {slots.default?.()}
        </Teleport>
      )
    }
  }
})